import { render } from "./BusinessPlanView.vue?vue&type=template&id=3553b6ef"
import script from "./BusinessPlanView.vue?vue&type=script&lang=js"
export * from "./BusinessPlanView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrateur\\Documents\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__